<app-loader *ngIf="isDisabled || isGDisabled"></app-loader>
<div class="card">
	<div class="card-header">
		<div class="row">
			<div class="col">
				Onboarding
			</div>
			<div class="col-auto">
				<button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
					[routerLink]="['/onboarding/register/menualinit/',0,this.Filter.Category]" [disabled]="isDisabled">
					<i class="bi bi-person-plus" *ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Add Employee':'Loading...'}}
				</button>
				<button type="button" class="btn btn-outline-primary ms-1" [disabled]="isDisabled"
					(click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
					aria-controls="collapseExample">
					<i class="bi bi-caret-down-fill" *ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Filter':'Loading...'}}
				</button>
				<button type="button" class="btn btn-outline-primary ms-1" [disabled]="isDisabled"
					(click)="ESS_GetEmployeeDumpFilter()"><i class="bi bi-file-earmark-spreadsheet-fill"
						*ngIf="!isDisabled"></i>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
						*ngIf="isDisabled"></span>
					{{!isDisabled?'Excel':'Loading...'}}</button>
			</div>
		</div>
	</div>
	<div class="card-body">
		<div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="mt-1">
			<div class="card">
				<div class="card-body py-2">
					<div class="row my-1">
						<div class="col-md-4">
							<label for="EmployeeCode" class="text-label-dark">Employee Code</label>
							<input class="form-control" placeholder="Ex. EMP001" id="EmployeeCode" name="EmployeeCode"
								[(ngModel)]="Filter.EmployeeCode" #EmployeeCode="ngModel" maxlength="100" />
						</div>
						<div class="col-md-4">
							<label for="OldEmployeeCode" class="text-label-dark">Old Employee Code</label>
							<input class="form-control" placeholder="Ex. EMP001" id="OldEmployeeCode"
								name="OldEmployeeCode" [(ngModel)]="Filter.EmployeeOldCode" #OldEmployeeCode="ngModel"
								maxlength="100" />
						</div>
						<div class="col-md-4">
							<label for="EmpName" class="text-label-dark">Employee Name</label>
							<input class="form-control" placeholder="Ex. John Alexander" id="EmpName" name="EmpName"
								[(ngModel)]="Filter.EmpName" #EmpName="ngModel" maxlength="100" />
						</div>
					</div>
					<div class="row my-1">
						<div class="col-md-4">
							<label for="BranchName" class="text-label-dark">Branch Name</label>
							<input class="form-control" placeholder="Ex. Mumbai" id="BranchName" name="BranchName"
								[(ngModel)]="Filter.BranchName" #BranchName="ngModel" maxlength="100" />
						</div>
						<!-- <div class="col-md-4">
							<label for="Category" class="text-label-dark mb-2">Employee Type</label>
							<br />
							@for (EmployeeCategory of common.EmployeeCategorys; track EmployeeCategory.EmployeeCategory;
							let i =
							$index) {
							<label class="form-check-label link-dark px-1" ngbButtonLabel>
								<input class="form-check-input" type="radio" [value]=EmployeeCategory.Value
									name='Category' [(ngModel)]="Filter.Category" [ngModelOptions]="{standalone: true}">
								{{EmployeeCategory.EmployeeCategory}}
							</label>
							}
							<label class="form-check-label link-dark px-1" ngbButtonLabel>
								<input class="form-check-input" type="radio" value='' name='Category'
									[(ngModel)]="Filter.Category" [ngModelOptions]="{standalone: true}">
								Both
							</label>
						</div> -->
						<div class="col-md-8">
							<label for="CustomSelect" class="text-label-dark">Custom</label>
							<div class="input-group mb-3">
								<ng-select name="FilterColumns" [items]="FilterColumns" bindLabel="FilterName"
									bindValue="ESS_CustomSearchFilterId" [(ngModel)]="Filter.Ess_CustomSearchFilterId"
									placeholder="Select Field" style="width: 13rem;" [appendTo]="'body'" required>
								</ng-select>
								<input class="form-control" placeholder="Ex. John Alexander" id="FilterValue"
									name="FilterValue" [(ngModel)]="Filter.FilterValue" #FilterValue="ngModel"
									maxlength="100" />
							</div>
						</div>
					</div>
				</div>
				<div class="card-footer">
					<div class="d-grid gap-2 d-md-flex justify-content-md-end">
						<button type="button" class="btn btn-primary" (click)="GetData();isCollapsed = !isCollapsed"
							[disabled]="isDisabled"><i class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
								*ngIf="isDisabled"></span>
							{{!isDisabled?'Apply':'Loading...'}}</button>
					</div>
				</div>
			</div>
		</div>
		<div class="pt-2">
			<div class="row">
				<div class="row">
					<div class="btn-group" role="group" aria-label="Basic example">
						<button type="button" class="btn btn-outline-primary" (click)="setSelectType(1)"
							style="width:100%" [class.active]="Filter.ListType === 1" [value]="1">
							<i class="bi bi-person-badge"></i> Employee
						</button>
						<button type="button" class="btn btn-outline-primary" (click)="setSelectType(2)"
							[class.active]="Filter.ListType === 2" style="width:100%" [value]="2">
							<i class="bi bi-pencil-square"></i> Draft Employee
						</button>
						<!-- <button type="button" class="btn btn-outline-primary" (click)="setSelectType(3)"
								style="width:100%" [value]="3" [class.active]="Filter.ListType === 3">
								<i class="bi bi-person-bounding-box"></i>Pre On Boarding Employee
							</button> -->
					</div>
				</div>
			</div>

			<div class="row p-2">
				<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
					class="customeDatatable table table-bordered">
					<thead class="table-light">
						<tr>
							<th [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}">
								Action</th>
							<th
								[ngClass]="{'colHide':(Filter.IsDraft === false) ||((Filter.IsDraft === true) && !this.common.PageRight.IsDelete)}">
								Delete
							</th>
							<th style="width: 300px;">Details</th>
							<th style="width: 150px">Branch</th>
							<th style="width: 100px">Old Code</th>
							<th style="width: 100px">Registration Date</th>
							<th style="width: 100px">Joining Date</th>
							<th style="width: 100px">Birth Date</th>
							<th style="width: 100px">Rating</th>
							<th style="width: 100px">Working Status</th>
							<th style="width: 100px">Active</th>
							<!-- <th style="width: 50px">Employee Type</th> -->
							<th style="width: 200px"
								[ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">Client
							</th>
							<th style="width: 200px"
								[ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">Site
							</th>
							<th style="width: 100px">AadhaarNo</th>
							<th style="width: 100px">PANNo</th>
							<th>Approval Status</th>
							<th style="width: 100px"
								[ngClass]="{'colHide': !this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable}">BGV
								Status</th>
							<!-- <th style="width: 150px"
								[ngClass]="{'colHide': !this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable || (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable && !Filter.IsDraft && Filter.ListType == 1)}">
								Bypass BGV</th> -->
							<!-- <th>Rating</th>
						<th>Progress</th> -->
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let element of EmployeeData; let i = index">
							<td [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}"
								class="p-1">
								<div ngbDropdown class="arrow-none text-center" container="body">
									<i class="bi bi-three-dots-vertical dropdown-toggle-none" ngbDropdownToggle></i>
									<div ngbDropdownMenu>
										<button ngbDropdownItem type="button"
											*ngIf="this.common.PageRight.IsEdit && (element['ApprovalStatus'] == null || this.common.ToLowerCase(element['ApprovalStatus']) == '' || this.common.ToLowerCase(element['ApprovalStatus']) == 'approved')"
											[routerLink]="['/onboarding/register/add/' + element['EmpMasterId'] + '/' + Filter.IsDraft]"><i
												class="bi bi-pencil-square me-2"></i>Edit</button>

										<button ngbDropdownItem type="button"
											*ngIf="this.common.PageRight.IsEdit && this.common.ToLowerCase(element['ApprovalStatus']) == 'rejected' && this.common.ToLowerCase(element['WorkingStatus']) == 'rejected'"
											(click)="Rejoin(element)"><i
												class="bi bi-pencil-square me-2"></i>Rejoin</button>

										<button ngbDropdownItem type="button" *ngIf="this.common.PageRight.IsView"
											[routerLink]="['/onboarding/register/detail/' + element['EmpMasterId'] + '/' + Filter.IsDraft]"><i
												class="bi bi-eye  me-2"></i>View</button>
									</div>
								</div>
							</td>
							<td
								[ngClass]="{'colHide':(Filter.IsDraft === false) ||((Filter.IsDraft === true) && !this.common.PageRight.IsDelete)}">
								<button class="btn btn-sm" name="delete" style="color: rgb(236, 4, 4);"
									(click)="DeleteDraft(element)"><i class="bi bi-trash-fill"></i></button>
							</td>
							<td style="width: 300px;">
								<div class="row" style="align-items: center;" style="align-items: center;width: 300px;">
									<div class="col-2">
										<img *ngIf="element['Photo'] != null && element['Photo'] != ''"
											(click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
											mat-card-image class="userImage"
											[src]="common.PhotoLink(element['Photo'])" />
										<div *ngIf="element['Photo'] == null || element['Photo'] == ''"
											(click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
											class="initial-image">
											<div class="image">
												{{common.getInitial(element['EmployeeName'])}}
											</div>
										</div>
									</div>
									<div class="col-10">
										<span class="text-label">{{element['EmployeeName']}}</span><br />
										<span class="text-label-light">#{{element['EmpCode']}} <span
												*ngIf="element['DesignationName'] != null && element['DesignationName'] != ''">[{{element['DesignationName']}}]</span></span><br />
									</div>
								</div>
							</td>
							<td style="width: 150px">
								<div style="width: 150px">{{element['BranchName']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['EmpOldCode']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['RegistrationDate']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['JoiningDate']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['BirthDate']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['Rating']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['WorkingStatus']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px"><span class="badge"
										[ngClass]="{'success': element['Active'],'danger': !element['Active']}">
										{{element['Active']?'Active':'Deactive'}}</span></div>
							</td>
							<!-- <td style="width: 50px">
								<div style="width: 50px">{{element['EmpType']}}</div>
							</td> -->
							<td style="width: 200px"
								[ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">
								<div style="width: 200px">{{element['ClientGroupName']}}</div>
							</td>
							<td style="width: 200px"
								[ngClass]="{'colHide': this.common.ToLowerCase(this.Filter.Category) == 'back'}">
								<div style="width: 200px">{{element['SiteName']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['AadharNo']}}</div>
							</td>
							<td style="width: 100px">
								<div style="width: 100px">{{element['PANNo']}}</div>
							</td>
							<td>{{(Filter.ListType == 1 || Filter.ListType == 2)?element['ApprovalStatus']:Filter.ListType ==
								3?element['Status']:''}}</td>
							<td [ngClass]="{'colHide': !this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable}">
								<span class="badge verify"
									*ngIf="element['BGVStatus'] != null && element['BGVStatus'] != ''"
									style="padding:3px;border-radius: 6px;"
									[ngStyle]="{ 'background':element['ColourCode']??'yellow'}">
									{{element['BGVStatus']}}
								</span>
							</td>
							<!-- <td style="width: 150px"
								[ngClass]="{'colHide': !this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable || (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable && !Filter.IsDraft && Filter.ListType == 1)}">
								<button style="width:max-content" class="btn btn-sm btn-primary" name="btn1"
									[disabled]="isDisabled" *ngIf="element['BGVStatus'] != '' && element['BGVStatus'] != null && this.common.ToLowerCase(element['BGVStatus']) != 'clear'
								&& (element['ApprovalStatus'] == null || this.common.ToLowerCase(element['ApprovalStatus']) == '')"
									(click)="FinalSave(element)">
									Process</button>
							</td> -->
							<!-- <td>
							{{element['Rating']}}<i class="bi bi-star-fill ms-1 editIcon"></i>
						</td>
						<td>
							<ngb-progressbar mode="determinate" [value]="60" style="border-radius: 5px;"
								*ngIf="i % 2==0 && i != 5" />
							<ngb-progressbar mode="determinate" class="progressworning" [value]="40"
								style="border-radius: 5px;" *ngIf="i % 2==1 && i != 5" />
							<ngb-progressbar mode="determinate" class="progresssuccess" [value]="100"
								style="border-radius: 5px;" *ngIf="i == 5" />
							<label style="float: inline-end; font-size: 10px; color: #585BD5;">{{i % 2==0 && i
								!=
								5?'60':i == 5?100:40}}%</label>

						</td> -->
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>